import { configureApi } from '@api/api'
import '@platform/index.css'
import { queryClient } from '@api/query-client'
import { activateChunkRecovery } from '@core/utils/error-handling/activate-chunk-recovery'
import { rootErrorHandlers } from '@core/utils/error-handling/root-error-handlers'
import { ThemeProvider } from '@design/contexts/ThemeContext'
import { TooltipProvider } from '@design/ui/tooltip'
import i18n, { i18nInit } from '@platform/i18n/i18n'
import { router } from '@platform/router'
import { ROUTES } from '@platform/router/paths'
import { initSentry } from '@platform/sentry'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'

if (import.meta.env.VITE_PLATFORM_SENTRY_DSN) {
  initSentry(router)
}

activateChunkRecovery(router)

i18nInit.then(() => {
  // Configure the shared API instance with platform-specific settings
  configureApi({
    onUnauthorized: () => router.navigate({ to: ROUTES.logOut }),
    language: i18n.language,
  })

  const rootElement = document.getElementById('root')
  if (!rootElement) throw new Error('Root element #root not found')

  const root = ReactDOM.createRoot(rootElement, rootErrorHandlers)
  root.render(
    <StrictMode>
      {/* Context Providers */}
      <I18nextProvider i18n={i18n}>
        <TooltipProvider>
          <ThemeProvider defaultTheme='system' storageKey='platform-ui-theme'>
            <QueryClientProvider client={queryClient}>
              {/* Main content */}
              <RouterProvider router={router} />
            </QueryClientProvider>
          </ThemeProvider>
        </TooltipProvider>
      </I18nextProvider>
    </StrictMode>
  )
})
